import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
import {baseApi} from "./rtk-api/baseApi";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import authSlice from "./auth/auth.slice";
import doctorsSlice from "./doctors/doctors.slice";
import reviewSlice from "./review/review.slice";
import appointmentSlice from "./appointment/appointment.slice";
import calendarSlice from "./calendar/calendar.slice";
import headerSlice from "./header/header.slice";
import procedureSlice from "./procedure/procedure.slice";
import specialitySlice from "./specialities/specialities.slice";
import monthDataSlice from "./month-data/month-data.slice";
import reconciliationSlice from "./reconcilation/reconciliation.slice";

export const store = configureStore({
    reducer: {
        auth:authSlice,
        doctor:doctorsSlice,
        review:reviewSlice,
        appointment:appointmentSlice,
        calendar:calendarSlice,
        header:headerSlice,
        procedure:procedureSlice,
        speciality:specialitySlice,
        monthData:monthDataSlice,
        reconciliation:reconciliationSlice,
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseApi.middleware)
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector